

const CSS=`

.custom-modal-overlay { position: fixed; inset: 0; background-color: rgba(0,0,0,0.5); backdrop-filter: blur(4px); z-index: 1100; display: flex; align-items: center; justify-content: center; animation: fadeIn 0.2s ease-out; }
.custom-modal-overlay.side-panel-overlay { justify-content: flex-end; }
.custom-modal-dialog { background: var(--surface-bg); width: 100%; max-width: 500px; max-height: 90vh; border-radius: var(--radius-lg); box-shadow: 0 10px 25px rgba(0,0,0,0.2); display: flex; flex-direction: column; overflow: hidden; animation: slideUp 0.3s ease-out; }
.custom-modal-header { padding: 1rem 1.25rem; border-bottom: 1px solid var(--ui-border); display: flex; justify-content: space-between; align-items: center; background: var(--surface-bg); }
.custom-modal-body { padding: 1.25rem; flex: 1; overflow-y: auto; background: var(--surface-bg); }
.custom-modal-footer { padding: 1rem 1.25rem; border-top: 1px solid var(--ui-border); background: var(--surface-bg); display: flex; justify-content: flex-end; gap: 0.75rem; }


.side-panel { background: var(--surface-bg); width: 100%; max-width: 500px; height: 100vh; box-shadow: -10px 0 25px rgba(0,0,0,0.1); display: flex; flex-direction: column; animation: slideInRight 0.3s ease-out; margin-left: auto; }
`

function SideDrawer({children,isOpen=false}){

    if(!isOpen) return


    return(
<>
  <style>{CSS}</style>
    <div className="custom-modal-overlay side-panel-overlay">
      <div className="side-panel">
        {children}
      </div>
    </div>
    </>
    )

}

export default SideDrawer